module.exports = __webpack_public_path__ + "static/media/ponto_base_cerca.dd912c47.svg";